import { Builder } from '@builder.io/react'
import { isBrowser } from '@patrianna/shared-utils'

import { NewOptInInfoCards } from 'components/BuildersCustomComponents/NewOptInInfoCards'
import { OptInInfoCards } from 'components/BuildersCustomComponents/OptInInfoCards'
import ReferFriendDataOld from 'components/BuildersCustomComponents/ReferFriendDataOld'
import { ReferFriendImportantInfo } from 'components/BuildersCustomComponents/ReferFriendImportantInfo'
import { ReferFriendInfoCards } from 'components/BuildersCustomComponents/ReferFriendInfoCards'
import ReferFriendsLinkOld from 'components/BuildersCustomComponents/ReferFriendLinkOld'
import { ReferFriendNoLimits } from 'components/BuildersCustomComponents/ReferFriendNoLimits'

import AllBingoRoomsContainer from './AllBingoRoomsContainer'
import BingoRoomsByIdContainer from './BingoRoomsByIdContainer'
import GamesByIdContainer from './GamesByIdContainer'
import GamesByTagContainer from './GamesByTagContainer'
import GcJackpotWinnersTable from './GcJackpotWinnersTable'
import OptimizedImage from './OptimizedImage'
import OptInPromoBanner from './OptInPromoBanner'
import OptInPromoButton from './OptInPromoButton'
import PromotionTermsAccordion from './PromotionTermsAccordion'
import ReferFriendData from './ReferFriendData'
import ReferFriendLink from './ReferFriendLink'

// register custom component to builder
export default function RegisteredBuilderCustomComponents(): void {
  if (!isBrowser()) {
    return undefined
  }

  Builder.registerComponent(GamesByTagContainer, {
    name: 'getGamesByTag',
    inputs: [{ name: 'tag', type: 'text' }],
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/slot-machine-outline.svg',
  })

  Builder.registerComponent(GamesByIdContainer, {
    name: 'getGamesById',
    inputs: [{ name: 'gameCodes', type: 'text', required: true }],
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/slot-machine-outline.svg',
  })

  Builder.registerComponent(AllBingoRoomsContainer, {
    name: 'getAllBingoRooms',
    image: 'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/ticket.svg',
  })

  Builder.registerComponent(BingoRoomsByIdContainer, {
    name: 'getBingoRoomsById',
    inputs: [
      { name: 'ids', type: 'text', required: true, helperText: 'Comma-separated room codes, e.g. parl_112,parl_111' },
    ],
    image: 'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/ticket.svg',
  })

  Builder.registerComponent(GcJackpotWinnersTable, {
    name: 'GcJackpotWinnersTable',
    inputs: [{ name: 'id', type: 'text' }],
    image: 'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/card-bulleted.svg',
  })

  Builder.registerComponent(OptimizedImage, {
    name: 'OptimizedImage',
    inputs: [
      { name: 'url', type: 'text' },
      { name: 'alt', type: 'text' },
    ],
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/arrow-up-bold-box-outline.svg',
  })

  Builder.registerComponent(ReferFriendData, {
    name: 'ReferFriendData',
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/slot-machine-outline.svg',
  })

  Builder.registerComponent(ReferFriendDataOld, {
    name: 'ReferFriendDataOld',
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/slot-machine-outline.svg',
  })

  Builder.registerComponent(ReferFriendLink, {
    name: 'ReferFriendLink',
    inputs: [{ name: 'shareMessage', type: 'text' }],
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/slot-machine-outline.svg',
  })

  Builder.registerComponent(ReferFriendsLinkOld, {
    name: 'ReferFriendLinkOld',
    inputs: [{ name: 'shareMessage', type: 'text' }],
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/slot-machine-outline.svg',
  })

  Builder.registerComponent(PromotionTermsAccordion, {
    name: 'PromotionTermsAccordion',
    inputs: [
      { name: 'title', type: 'text' },
      { name: 'content', type: 'richText', defaultValue: '' },
    ],
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/slot-machine-outline.svg',
  })

  Builder.registerComponent(ReferFriendInfoCards, {
    name: 'ReferFriendInfoCards',
    inputs: [{ name: 'data', type: 'json' }],
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/slot-machine-outline.svg',
  })

  Builder.registerComponent(ReferFriendImportantInfo, {
    name: 'ReferFriendImportantInfo',
    inputs: [
      { name: 'title', type: 'text' },
      { name: 'text', type: 'text' },
    ],
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/slot-machine-outline.svg',
  })

  Builder.registerComponent(ReferFriendNoLimits, {
    name: 'ReferFriendNoLimits',
    inputs: [{ name: 'text', type: 'text' }],
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/slot-machine-outline.svg',
  })

  Builder.registerComponent(OptInPromoButton, {
    name: 'OptInPromoButton',
    inputs: [
      { name: 'label', type: 'text', defaultValue: 'Opt in', required: true },
      { name: 'utmCode', type: 'text', required: true },
    ],
    image: 'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/poker-chip.svg',
  })

  Builder.registerComponent(OptInPromoBanner, {
    name: 'OptInPromoBanner',
    inputs: [
      { name: 'imageUrl', type: 'text', required: true },
      { name: 'utmCode', type: 'text', required: true },
      { name: 'alternativeText', type: 'text' },
    ],
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/gift-open-outline.svg',
  })

  // TODO: Remove this component after migration to new Opt In Info Cards
  Builder.registerComponent(OptInInfoCards, {
    name: 'OptInInfoCard',
    inputs: [
      { name: 'firstBlockTitle', type: 'text' },
      { name: 'firstBlockPrefixSubtitle', type: 'text' },
      { name: 'firstBlockSubtitle', type: 'text' },
      { name: 'secondBlockTitle', type: 'text' },
      { name: 'secondBlockSubtitle', type: 'text' },
      { name: 'thirdBlockTitle', type: 'text' },
      { name: 'thirdBlockSubtitle', type: 'text' },
    ],
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/gift-open-outline.svg',
  })

  Builder.registerComponent(NewOptInInfoCards, {
    name: 'NewOptInInfoCards',
    inputs: [{ name: 'data', type: 'json' }],
    image:
      'https://storage.googleapis.com/www.ysi-group.com/ysi-images/swimlane-icons/light-theme/gift-open-outline.svg',
  })
}
